// Verificar que estamos en el navegador
const isBrowser = () => typeof window !== 'undefined';

// Configuración de Supabase usando variables de entorno
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

// Validar que las variables de entorno estén definidas
if (!supabaseUrl || !supabaseAnonKey) {
  console.error('Error: Las variables de entorno de Supabase no están configuradas correctamente');
  console.log('VITE_SUPABASE_URL:', import.meta.env.VITE_SUPABASE_URL ? 'Definida' : 'No definida');
  console.log('VITE_SUPABASE_ANON_KEY:', import.meta.env.VITE_SUPABASE_ANON_KEY ? 'Definida' : 'No definida');
}

// Crear el cliente de Supabase solo en el navegador
let supabase = {
  from: () => {
    console.warn('Supabase no está inicializado correctamente');
    return {
      select: () => {
        console.warn('No se puede ejecutar select: Supabase no está inicializado');
        return { data: null, error: new Error('Supabase no está inicializado') };
      }
    };
  }
};

try {
  if (isBrowser()) {
    if (supabaseUrl && supabaseAnonKey) {
      const { createClient } = await import('@supabase/supabase-js');
      supabase = createClient(supabaseUrl, supabaseAnonKey, {
        auth: {
          persistSession: false,
          autoRefreshToken: false,
          detectSessionInUrl: false
        }
      });
      console.log('✅ Supabase client inicializado correctamente');

      // Probar la conexión
      const { data, error } = await supabase
        .from('opiniones')
        .select('*')
        .limit(1);

      if (error) {
        console.error('❌ Error al conectar con Supabase:', error);
      } else {
        console.log('✅ Conexión con Supabase establecida');
      }
    } else {
      console.error('❌ No se pudo inicializar Supabase: faltan credenciales');
    }
  } else {
    console.warn('⚠️ Supabase no se inicializó: no se está ejecutando en el navegador');
  }
} catch (error) {
  console.error('❌ Error al inicializar Supabase:', error);
}

export { supabase };
